import { AsyncPipe, NgClass, NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { map, Observable, switchMap, withLatestFrom } from 'rxjs';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { BildungsangeboteService } from '../../services/bildungsangebote.service';
import { LoaderService } from '../../services/loader.service';
import {
  BildungsBereich,
  BildungsbereichService
} from '../../services/state/bildungsbereich.service';
import { ThemenfelderService } from '../../services/themenfelder/themenfelder.service';
import { ScrollToAndFocusDirective } from '../../shared/directives';
import { BearbeitenButtonComponent } from './bearbeiten-button/bearbeiten-button.component';
import { ThemenfeldBildungsbereichChangeComponent } from './themenfeld-bildungsbereich-change/themenfeld-bildungsbereich-change.component';
import { ThemenfelderSelectionComponent } from './themenfelder-selection/themenfelder-selection.component';

@Component({
  selector: 'now-wbsuche-lib-themenfelder',
  imports: [
    BreadcrumbComponent,
    AsyncPipe,
    BearbeitenButtonComponent,
    ThemenfelderSelectionComponent,
    RouterLink,
    NgOptimizedImage,
    ScrollToAndFocusDirective,
    NgTemplateOutlet,
    ThemenfeldBildungsbereichChangeComponent,
    NgClass
  ],
  templateUrl: './themenfelder.component.html',
  styleUrl: './themenfelder.component.scss'
})
export class ThemenfelderComponent {
  themenfelderService = inject(ThemenfelderService);
  private readonly bildungsangeboteService = inject(BildungsangeboteService);

  public readonly loaderService = inject(LoaderService);

  /**
   * Observable mit den Themenfeldspezialisierungen zum ausgewählten Themenfeldschwerpunkt
   * Lädt zusätzlich die Anzahlt der Angebote die pro Themenfeldspezialisierung vorhanden sind.
   * Anschließend werden die Daten anhand der Bezeichnung sortiert
   */
  public themenfeldSpezialisierungenMitCounts$: Observable<
    { kurzBezeichnungNeutral: string; count: number }[]
  > = this.themenfelderService.themenfeldSpezialisierungen$.pipe(
    map((themenfeldSpezialisierungen) =>
      themenfeldSpezialisierungen.map(({ kurzBezeichnungNeutral }) => kurzBezeichnungNeutral)
    ),
    withLatestFrom(this.themenfelderService.ausgewaehlterBildungsbereich$),
    switchMap(([kurzBezeichnungenNeutral, bildungsbereich]) =>
      this.bildungsangeboteService.getThemenfelderCounts$(
        kurzBezeichnungenNeutral,
        BildungsbereichService.isUte(bildungsbereich)
      )
    ),
    map((value: { [key: string]: number }) => Object.entries(value)),
    map((entries) =>
      entries
        .map(([kurzBezeichnungNeutral, count]) => ({ kurzBezeichnungNeutral, count }))
        .sort((prev, next) => (prev.kurzBezeichnungNeutral > next.kurzBezeichnungNeutral ? 1 : -1))
    )
  );

  public bildungsbereichLabel$ = this.themenfelderService.ausgewaehlterBildungsbereich$.pipe(
    map((bildungsbereich) =>
      bildungsbereich === BildungsBereich.Erweitern
        ? 'Wissen erweitern'
        : 'Neuen Abschluss erwerben'
    )
  );
}
